import styled from 'styled-components'

export const EmptyContainer = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: 0 auto;
  padding: 100px 30px;
  min-height: 400px;
`
